import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'

import Radio from 'common/components/form/radio'
import ConfigMenuItem from '../configMenuItem'
import ConfigMenuSection from '../configMenuSection'
import { useTransmissionContext } from 'modules/transmission/context'
import { ON_FIRE_LANGUAGE_LABEL } from 'modules/transmission/constants'

import './languagesSection.scss'

const LanguagesSection = () => {
  const { t } = useTranslation()
  const { onFireLanguages, transmissionData: { code } } = useTransmissionContext()
  const history = useHistory()

  if (!onFireLanguages?.length) {
    return null
  }

  return (
    <ConfigMenuSection className="language-section" title={t('general.audio_and_languages')}>
      {onFireLanguages.map(({ language, scheduleCode }) => {
        const isSelected = scheduleCode === code

        return (
          <ConfigMenuItem
            onClick={() => history.push(`/${scheduleCode}`)}
            isHighlighted={isSelected} key={language}>
            <span>{ON_FIRE_LANGUAGE_LABEL[language]}</span>
            <Radio checked={isSelected} className="language-input" readOnly />
          </ConfigMenuItem>
        )
      })}
    </ConfigMenuSection>
  )
}

export default LanguagesSection
